export default {
    sales: [],
    loading: false,
    leaderships: [],
    params: {
        seller_id: null,
        leadership_id: null
    }
};
